// VERSION: 1.0.0
// AUTHOR: AGALYA

import BusinessLoanDisbursementActionTypes from './business-loan-disbursement.types';

/** ***************** FETCH BUSINESS LOAN INDEX START *********************** */
export const fetchBusinessLoanIndexStart = (addData: any) => ({
	type: BusinessLoanDisbursementActionTypes.FETCH_BUSINESS_LOAN_INDEX_START,
	payload: addData,
});

export const fetchBusinessLoanIndexSuccess = (successData: any) => ({
	type: BusinessLoanDisbursementActionTypes.FETCH_BUSINESS_LOAN_INDEX_SUCCESS,
	payload: successData,
});

export const fetchBusinessLoanIndexFailure = (failureData: any) => ({
	type: BusinessLoanDisbursementActionTypes.FETCH_BUSINESS_LOAN_INDEX_FAILURE,
	payload: failureData,
});

export const fetchBusinessLoanIndexResponseResetStart = () => ({
	type: BusinessLoanDisbursementActionTypes.FETCH_BUSINESS_LOAN_INDEX_RESPONSE_RESET,
});

export const fetchBusinessLoanIndexResponseChanged = () => ({
	type: BusinessLoanDisbursementActionTypes.FETCH_BUSINESS_LOAN_INDEX_RESPONSE_CHANGED,
});

/** ***************** FETCH BUSINESS LOAN INDEX END *********************** */

/** ***************** FETCH FINANCE BASED ACCOUNT TYPE START *********************** */
export const fetchFinanceBaseAccountTypeStart = (addData: any) => ({
	type: BusinessLoanDisbursementActionTypes.FETCH_FINANCE_BASED_ACCOUNT_TYPE_START,
	payload: addData,
});

export const fetchFinanceBaseAccountTypeSuccess = (successData: any) => ({
	type: BusinessLoanDisbursementActionTypes.FETCH_FINANCE_BASED_ACCOUNT_TYPE_SUCCESS,
	payload: successData,
});

export const fetchFinanceBaseAccountTypeFailure = (failureData: any) => ({
	type: BusinessLoanDisbursementActionTypes.FETCH_FINANCE_BASED_ACCOUNT_TYPE_FAILURE,
	payload: failureData,
});

export const fetchFinanceBaseAccountTypeResponseResetStart = () => ({
	type: BusinessLoanDisbursementActionTypes.FETCH_FINANCE_BASED_ACCOUNT_TYPE_RESPONSE_RESET,
});

export const fetchFinanceBaseAccountTypeResponseChanged = () => ({
	type: BusinessLoanDisbursementActionTypes.FETCH_FINANCE_BASED_ACCOUNT_TYPE_RESPONSE_CHANGED,
});

/** ***************** FETCH FINANCE BASED ACCOUNT TYPE END *********************** */

/** ***************** CREATE BUSINESS LOAN DISBURSEMENT START *********************** */
export const businessLoanDisbursmentStart = (disbuseData: any) => ({
	type: BusinessLoanDisbursementActionTypes.BUSINESS_LOAN_DISBURSEMENT_START,
	payload: disbuseData,
});

export const businessLoanDisbursmentSuccess = (successData: any) => ({
	type: BusinessLoanDisbursementActionTypes.BUSINESS_LOAN_DISBURSEMENT_SUCCESS,
	payload: successData,
});

export const businessLoanDisbursmentFailure = (failureData: any) => ({
	type: BusinessLoanDisbursementActionTypes.BUSINESS_LOAN_DISBURSEMENT_FAILURE,
	payload: failureData,
});

export const businessLoanDisbursmentResponseResetStart = () => ({
	type: BusinessLoanDisbursementActionTypes.BUSINESS_LOAN_DISBURSEMENT_RESPONSE_RESET,
});

export const businessLoanDisbursmentResponseChanged = () => ({
	type: BusinessLoanDisbursementActionTypes.BUSINESS_LOAN_DISBURSEMENT_RESPONSE_CHANGED,
});

/** ***************** CREATE BUSINESS LOAN DISBURSEMENT END *********************** */

/** ***************** START FETCH BUSINESS LOAN INFO DETAILS *********************** */
export const fetchBusinessLoanInfoStart = (infoData: any) => ({
	type: BusinessLoanDisbursementActionTypes.FETCH_BUSINESS_LOAN_INFO_DETAILS_START,
	payload: infoData,
});

export const fetchBusinessLoanInfoSuccess = (successData: any) => ({
	type: BusinessLoanDisbursementActionTypes.FETCH_BUSINESS_LOAN_INFO_DETAILS_SUCCESS,
	payload: successData,
});

export const fetchBusinessLoanInfoFailure = (failureData: any) => ({
	type: BusinessLoanDisbursementActionTypes.FETCH_BUSINESS_LOAN_INFO_DETAILS_FAILURE,
	payload: failureData,
});

export const fetchBusinessLoanInfoResponseResetStart = () => ({
	type: BusinessLoanDisbursementActionTypes.FETCH_BUSINESS_LOAN_INFO_DETAILS_RESPONSE_RESET,
});

export const fetchBusinessLoanInfoResponseChanged = () => ({
	type: BusinessLoanDisbursementActionTypes.FETCH_BUSINESS_LOAN_INFO_DETAILS_RESPONSE_CHANGED,
});

/** ***************** END FETCH BUSINESS LOAN INFO DETAILS *********************** */

/** ***************** START GET BUSINESS LIST *********************** */
export const getBusinessListStart = (businessData: any) => ({
	type: BusinessLoanDisbursementActionTypes.GET_BUSINESS_LIST_START,
	payload: businessData,
});

export const getBusinessListSuccess = (successData: any) => ({
	type: BusinessLoanDisbursementActionTypes.GET_BUSINESS_LIST_SUCCESS,
	payload: successData,
});

export const getBusinessListFailure = (failureData: any) => ({
	type: BusinessLoanDisbursementActionTypes.GET_BUSINESS_LIST_FAILURE,
	payload: failureData,
});

export const getBusinessListResponseResetStart = () => ({
	type: BusinessLoanDisbursementActionTypes.GET_BUSINESS_LIST_RESPONSE_RESET,
});

export const getBusinessListResponseChanged = () => ({
	type: BusinessLoanDisbursementActionTypes.GET_BUSINESS_LIST_RESPONSE_CHANGED,
});

/** ***************** END GET BUSINESS LIST *********************** */
